import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1d93fd7c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "d-flex gap-5",
  style: {"height":"200px"}
}
const _hoisted_2 = {
  class: "card",
  style: {"flex":"1"}
}
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = { class: "d-flex justify-content-between" }
const _hoisted_5 = { class: "card-title" }
const _hoisted_6 = { class: "card-title" }
const _hoisted_7 = {
  class: "d-flex justify-content-center align-items-center",
  style: {"height":"100%"}
}
const _hoisted_8 = {
  class: "card",
  style: {"flex":"1"}
}
const _hoisted_9 = { class: "card-body" }
const _hoisted_10 = { class: "card-title" }
const _hoisted_11 = {
  key: 0,
  class: "px-4 flex flex-row mt-3",
  style: {"height":"100%"}
}
const _hoisted_12 = ["href"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-file-earmark-text-fill icon-file" }, null, -1))
const _hoisted_14 = { class: "text-file" }
const _hoisted_15 = ["href"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-link-45deg icon-file" }, null, -1))
const _hoisted_17 = { class: "text-file" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-camera-reels-fill icon-file" }, null, -1))
const _hoisted_20 = { class: "text-file" }
const _hoisted_21 = ["href"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-cpu icon-file" }, null, -1))
const _hoisted_23 = { class: "text-file" }
const _hoisted_24 = ["href"]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-files icon-file" }, null, -1))
const _hoisted_26 = { class: "text-file" }
const _hoisted_27 = {
  key: 1,
  class: "d-flex justify-content-center align-items-center",
  style: {"height":"100%"}
}
const _hoisted_28 = { class: "text-file" }

import { computed, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';
import ApiService from '@/core/services/ApiService';
import { Mutations } from '@/store/enums/StoreEnums';

import AchivmentModal from './AchivmentModal.vue';
import FinishMachineModal from './FinishMachineModal.vue';
import ButtonShareOnLinkedin from '../ui/ButtonShareOnLinkedin.vue';
import Machine_video_modal from '@/components/machine/machine_video_modal.vue';

interface Attachment {
    id: number;
    name: string;
    url: string;
    metadata: any;
    type: 'machine' | 'link' | 'doc' | 'video' | string ;
    [key: string]: any
}

interface Challenge {
    id?: number | string;
    name?: string;
    percentage: number;
    attachments: Attachment[];
    total_flags: number;
    instance?: {
        is_active?: boolean;
        ip_address?: string;
        shutdown?: string;
        machine_id?: string;
    };
    [key: string]: any
}


export default /*#__PURE__*/_defineComponent({
  props: {
    challenge: null
  },
  setup(__props: any) {

const props = __props as {
    challenge: Challenge
}

const { t } = useI18n();
const store = useStore();
const userStats = ref({})
// const shareUrl = computed(() => {
//   return process.env.VUE_APP_SHARE_URL + 
//     'achievement/challenge/' + props.challenge.id + 
//     '/user/' + 12

// })
const shareUrl = computed(() => `${process.env.VUE_APP_SHARE_URL}achievement/challenge/${props.challenge.id}/user/${store.getters.currentUser.id}`);
const currentLanguage = computed(() => store.getters.getCurrentLanguage || localStorage.getItem('currentLanguage'));

const challengerCompleted = computed(() => props.challenge.percentage === 100);


// shareOnLinkedin(challenge_id, user_id) {
//   const url = `${process.env.VUE_APP_SHARE_URL}achievement/challenge/${challenge_id}/user/${user_id}`;
//   const linkedinUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${url}`;
//   window.open(linkedinUrl, "_blank");
// }





const attachments = computed(() => ({
    machine: props.challenge.attachments.filter(att => att.type === 'machine'),
    link: props.challenge.attachments.filter(att => att.type === 'link'),
    doc: props.challenge.attachments.filter(att => att.type === 'doc'),
    video: props.challenge.attachments.filter(att => att.type === 'video'),
    others: props.challenge.attachments.filter(att => !['machine', 'link', 'doc', 'video'].includes(att.type)),
}))

const flagsCompleted = parseFloat(((props.challenge.percentage / 100) * props.challenge.total_flags).toString()).toFixed(0)

const achivementModal = ref<InstanceType<typeof AchivmentModal> | null>(null)
const videModal = ref<InstanceType<typeof Machine_video_modal> | null>(null)
const showFinishMachineModal = ref(false)
const isStoppingMachine = ref(false)

const hasActiveMachineInstance = computed(() => Boolean(props.challenge?.instance?.is_active))

watch(
    () => props.challenge?.percentage,
    async (newPercentage, oldPercentage) => {
        if (newPercentage === 100 && oldPercentage !== undefined && oldPercentage < 100) {
            await achivementModal.value?.open()
        }
    }
)


const showVideoModal = (video: string, title: string) => {
    videModal.value?.showModal(video, null, title)
}

const onAchivementModalClosed = () => {
    if (!hasActiveMachineInstance.value) {
        return
    }

    showFinishMachineModal.value = true
}

const closeFinishMachineModal = () => {
    showFinishMachineModal.value = false
}

const finishMachineInstance = async () => {
    const challengeId = props.challenge?.id

    if (!challengeId || isStoppingMachine.value) {
        return
    }

    isStoppingMachine.value = true

    try {
        const { data } = await ApiService.get(`labs/challenges/${challengeId}/stop`)

        if (!data.success) {
            return
        }

        store.commit(Mutations.SET_CHALLENGES, data.challenge)
        showFinishMachineModal.value = false
    } catch (error) {
        console.error('Error stopping challenge instance:', error)
    } finally {
        isStoppingMachine.value = false
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(AchivmentModal, {
      ref_key: "achivementModal",
      ref: achivementModal,
      "challenge-id": props.challenge.id,
      "challenge-name": props.challenge.name || '',
      "user-nick": _unref(store).getters.currentUser?.nick || _unref(store).getters.currentUser?.username || 'No nick',
      onClosed: onAchivementModalClosed
    }, null, 8, ["challenge-id", "challenge-name", "user-nick"]),
    _createVNode(FinishMachineModal, {
      show: showFinishMachineModal.value,
      loading: isStoppingMachine.value,
      onClose: closeFinishMachineModal,
      onContinueUsing: closeFinishMachineModal,
      onFinish: finishMachineInstance
    }, null, 8, ["show", "loading"]),
    _createVNode(Machine_video_modal, {
      ref_key: "videModal",
      ref: videModal
    }, null, 512),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(_unref(t)(`${_unref(currentLanguage)}.machine.your_progress_on_this_machine_is`)) + ": " + _toDisplayString(props.challenge.percentage) + "%", 1),
          _createElementVNode("h5", _hoisted_6, "Flags: " + _toDisplayString(_unref(flagsCompleted)) + " / " + _toDisplayString(props.challenge.total_flags), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(ButtonShareOnLinkedin, {
            url: _unref(shareUrl),
            disabled: !_unref(challengerCompleted)
          }, null, 8, ["url", "disabled"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", null, [
          _createElementVNode("h5", _hoisted_10, " " + _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.attachments`)), 1)
        ]),
        (props.challenge.attachments)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(attachments).doc, (attachment) => {
                return (_openBlock(), _createElementBlock("a", {
                  key: attachment.id,
                  href: attachment.url,
                  target: "_blank",
                  class: "d-flex align-items-center my-2"
                }, [
                  _hoisted_13,
                  _createElementVNode("p", _hoisted_14, _toDisplayString(attachment.name), 1)
                ], 8, _hoisted_12))
              }), 128)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(attachments).link, (attachment) => {
                return (_openBlock(), _createElementBlock("a", {
                  key: attachment.id,
                  href: attachment.url,
                  target: "_blank",
                  class: "d-flex align-items-center my-2"
                }, [
                  _hoisted_16,
                  _createElementVNode("p", _hoisted_17, _toDisplayString(attachment.name), 1)
                ], 8, _hoisted_15))
              }), 128)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(attachments).video, (attachment) => {
                return (_openBlock(), _createElementBlock("a", {
                  key: attachment.id,
                  onClick: () => showVideoModal(attachment.url, attachment.name),
                  class: "d-flex align-items-center my-2"
                }, [
                  _hoisted_19,
                  _createElementVNode("p", _hoisted_20, _toDisplayString(attachment.name), 1)
                ], 8, _hoisted_18))
              }), 128)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(attachments).machine, (attachment) => {
                return (_openBlock(), _createElementBlock("a", {
                  key: attachment.id,
                  href: attachment.url,
                  target: "_blank",
                  class: "d-flex align-items-center my-2"
                }, [
                  _hoisted_22,
                  _createElementVNode("p", _hoisted_23, _toDisplayString(attachment.name), 1)
                ], 8, _hoisted_21))
              }), 128)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(attachments).others, (attachment) => {
                return (_openBlock(), _createElementBlock("a", {
                  key: attachment.id,
                  href: attachment.url,
                  target: "_blank",
                  class: "d-flex align-items-center my-2"
                }, [
                  _hoisted_25,
                  _createElementVNode("p", _hoisted_26, _toDisplayString(attachment.name), 1)
                ], 8, _hoisted_24))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_27, [
              _createElementVNode("p", _hoisted_28, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.no_attachments`)), 1)
            ]))
      ])
    ])
  ]))
}
}

})